const omBtnElement = document.querySelector("#openModalBtn");
const fwwwlocale = getShopifyLocale();

if (omBtnElement) {
  omBtnElement.addEventListener("click", function () {
    var productTitleElement = document.querySelector(".product-title");
    var vehicleInfoElement = document.querySelector(
      "#vInfo"
    );
    var vehicleOptionElement = document.querySelector(
      "#vOpt"
    );
    var skuElement = document.querySelector(".variant_sku");
    var currentUrl = window.location.href;

    var productTTitle = productTitleElement
      ? productTitleElement.textContent
      : "";
    var vehicleIInfo = vehicleInfoElement ? vehicleInfoElement.textContent : "";
    var vehicleOOption = vehicleOptionElement
      ? vehicleOptionElement.textContent
      : "";
    var skuu = skuElement ? skuElement.textContent : "";
    var urll = currentUrl ? currentUrl : "";

    document.getElementById("ProductTitle").value = productTTitle;
    document.getElementById("VehicleInfo").value = vehicleIInfo;
    document.getElementById("VehicleOption").value = vehicleOOption;
    document.getElementById("SKU").value = skuu;
    document.getElementById("URL").value = urll;
  });
}

function getShopifyLocale() {
  try {
    const el = document.getElementById("shopify-features");
    if (!el) return "en";

    const data = JSON.parse(el.textContent);
    return data.locale || "en";
  } catch (e) {
    console.error("Failed to read Shopify locale:", e);
    return "en";
  }
}

function checkEmails() {
  var email = document.getElementById("Email").value.toLowerCase();
  var confirmEmail = document
    .getElementById("confirmEmail")
    .value.toLowerCase();

  if (email !== confirmEmail) {
    return false;
  }

  return true;
}

document.addEventListener("DOMContentLoaded", function () {
  var openModalBtn = document.getElementById("openModalBtn");
  var modal = document.getElementById("mySTEModal");
  var span = document.getElementsByClassName("close")[0];
  var form = document.getElementById("myForm");
  var hiddenFrame = document.getElementById("hiddenFrame");

  if (openModalBtn) {
    openModalBtn.onclick = function () {
      if ($(modal).is(":visible")) {
        $(modal).fadeOut(300);
      } else {
        $(modal).fadeIn(300);
      }
    };

    span.onclick = function () {
      modal.style.display = "none";
    };

    form.addEventListener("submit", function (event) {
      if (checkEmails()) {
        if (fwwwlocale == 'fr') {
          openModalBtn.textContent = "Chargement...";
        } else {
          openModalBtn.textContent = "Loading...";
        }
        modal.style.display = "none";
      } else {
        if (fwwwlocale == 'fr') {
          alert("Les adresses courriel ne correspondent pas.");
        } else {
          alert("Email addresses do not match.");
        }
      }
    });

    hiddenFrame.addEventListener("load", function () {
      if (fwwwlocale == 'fr') {
        openModalBtn.textContent = "Soumis";
      } else {
        openModalBtn.textContent = "Submitted";
      }
      openModalBtn.disabled = true;
      form.reset();
    });
  }
});
